<template>
  <div ref="popupBox" class="popup-box">
    <div class="popup-trigger" @click.prevent="togglePopup">
      <slot name="trigger"></slot>
    </div>
    <div
      ref="popupContent"
      v-show="isPopupVisible"
      :class="clsx('popup-content-wrapper', { 'popup-content-wrapper--visible': isPopupVisible })"
      role="dialog"
      :aria-hidden="!isPopupVisible"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import clsx from 'clsx';
import { popupView } from '../../lib';

export default {
  mixins: [ popupView ],
  methods: { clsx },
  created() {
    this.$eventBus.$on('popup-close', this.closePopup);
  },
  beforeDestroy() {
    this.$eventBus.$off('popup-close', this.closePopup);
  }
};
</script>

<style lang="scss" scoped>
.popup-content-wrapper {
  display: none;
  z-index: 100;

  &--visible {
    display: block;

    @media (max-width: 550px) {
      right: 24px !important;
      left: 24px !important;
    }
  }
}
</style>
